import EmailTemplatesModel from './EmailTemplatesModel';
import EmailTemplatesTableModel from './EmailTemplatesTableModel';

export class EmailTemplate{
  public static createEmpty(): EmailTemplate {
    return new EmailTemplate();
  }
  constructor(
    public RawHtml: string = '',
    public ProcessedHtml: string = '',
    public TemplateData: EmailTemplatesModel = EmailTemplatesModel.createEmpty(),
    public AvailableTemplates: EmailTemplatesTableModel[] = [],
    public SelectedTemplate: EmailTemplatesModel = EmailTemplatesModel.createEmpty(),
  ){}
}

